import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/contexts/LanguageContext";
import { Cookie } from "lucide-react";

export const CONSENT_KEY = "rv_cookie_consent";
export const getConsent = () => localStorage.getItem(CONSENT_KEY);

const setConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value);
  window.adsbygoogle = window.adsbygoogle || [];
  if (value === "granted") window.adsbygoogle.pauseAdRequests = 0;
  window.dispatchEvent(new Event("rv-consent"));
};

export const CookieBanner = () => {
  const { t } = useLang();
  const [visible, setVisible] = useState(() => !getConsent());

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#0A0A0A] text-white border-t-2 border-[#FFCC00] p-4 sm:p-5"
      style={{ paddingBottom: "calc(1rem + env(safe-area-inset-bottom))" }}
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row sm:items-center gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <Cookie size={16} className="text-[#FFCC00] flex-shrink-0" />
            <span className="font-display font-black tracking-tight">{t.cookies.title}</span>
          </div>
          <p className="text-sm text-[#A0A0A0] mt-1 leading-snug">
            {t.cookies.text}{" "}
            <Link data-testid="cookie-policy-link" to="/privacy" className="underline text-white hover:text-[#FFCC00]">{t.cookies.more}</Link>
          </p>
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <button
            data-testid="cookie-reject-btn"
            onClick={() => choose("denied")}
            className="flex-1 sm:flex-none h-12 sm:h-10 px-5 border border-white/40 font-display font-bold text-sm hover:border-white transition-colors"
          >
            {t.cookies.reject}
          </button>
          <button
            data-testid="cookie-accept-btn"
            onClick={() => choose("granted")}
            className="flex-1 sm:flex-none h-12 sm:h-10 px-6 bg-[#FFCC00] text-black font-display font-black text-sm hover:bg-white transition-colors"
          >
            {t.cookies.accept}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
